import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import { BLACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import SectionCard from '../../positionTemplate/components/SectionCard';

import SaveStatusIndicator from './SaveStatusIndicator';
import SectionTitle from './SectionTitle';

const rowSx = { alignItems: 'flex-start', display: 'flex', gap: '4px', padding: '4px 0' };

const checkboxSx = {
  color: BLACK[50],
  marginLeft: '-9px',
  marginTop: '-9px',
  '&.Mui-checked': { color: PRIMARY_PURPLE[70] },
};

const labelSx = { color: BLACK[100], fontFamily: PRIMARY_FONT[500], fontSize: '14px' };

const ApprovalCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();
  const isApproved = !!positionTemplate.approved;

  return (
    <SectionCard
      header={
        <>
          <SectionTitle>{intl.formatMessage({ id: 'pt.detail.approval' })}</SectionTitle>
          <SaveStatusIndicator status={getStatus('approved')} />
        </>
      }
    >
      <Box sx={rowSx}>
        <Checkbox
          id="pt-detail-approved"
          checked={isApproved}
          onChange={(event) =>
            saveField({
              key: 'approved',
              fields: { approved: event.target.checked },
              patch: { approved: event.target.checked },
            })
          }
          sx={checkboxSx}
        />
        <Typography component="label" htmlFor="pt-detail-approved" sx={labelSx}>
          {intl.formatMessage({ id: 'pt.detail.approved' })}
        </Typography>
      </Box>
    </SectionCard>
  );
};

ApprovalCard.propTypes = {
  positionTemplate: PropTypes.shape({
    approved: PropTypes.bool,
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default ApprovalCard;
